import { IJitsiMeetExternalApi } from "@jitsi/react-sdk/lib/types";
import { CallEnd, Mic, MicOff, Videocam, VideocamOff } from "@mui/icons-material";
import CircleButton, { BackgroundColorCircleButtonEnum, TextColorCircleButtonEnum } from "components/atoms/CircleButton/CircleButton";
import { MutableRefObject, useContext } from "react";
import { useIntl } from "react-intl";
import VideoCallContext from "../VideoCallContext";

export type VideoToolbarProps = {
  apiRef: MutableRefObject<IJitsiMeetExternalApi>;
  className?: string;
  isHangupButtonDisplayed?: boolean;
}

const VideoCallToolbar = ({ apiRef, className, isHangupButtonDisplayed = true }: VideoToolbarProps): JSX.Element => {
  const intl = useIntl();
  const videoCallContext = useContext(VideoCallContext);
  
  return (
    <div className={`flex justify-between px-2w py-1w w-[325px] h-fit rounded-xl bg-black bg-opacity-50 ${className}`}>
      {isHangupButtonDisplayed && <CircleButton 
        backgroundColor={BackgroundColorCircleButtonEnum.CLASSIC_RED} 
        className="flex-1"
        icon={<CallEnd />} 
        onClick={() => apiRef.current.executeCommand('hangup')} 
        text={intl.formatMessage({ id: 'videoCall.call.toolbar.leaveCall' })}
        textColor={TextColorCircleButtonEnum.WHITE} />}
      <CircleButton 
        className="flex-1"
        icon={videoCallContext.isMicrophoneMuted ? <MicOff /> : <Mic />}
        onClick={() => apiRef.current.executeCommand('toggleAudio')}
        text={videoCallContext.isMicrophoneMuted ?
          intl.formatMessage({ id: 'videoCall.call.toolbar.microphoneMuted' }) :
          intl.formatMessage({ id: 'videoCall.call.toolbar.microphoneActive' })
        }
        textColor={TextColorCircleButtonEnum.WHITE} />
      <CircleButton 
        className="flex-1"
        icon={videoCallContext.isCameraDisabled ? <VideocamOff /> : <Videocam />}
        onClick={() => apiRef.current.executeCommand('toggleVideo')}
        text={videoCallContext.isCameraDisabled ?
          intl.formatMessage({ id: 'videoCall.call.toolbar.cameraMuted' }) :
          intl.formatMessage({ id: 'videoCall.call.toolbar.cameraActive' })
        }
        textColor={TextColorCircleButtonEnum.WHITE} />
    </div>
  )
}

export default VideoCallToolbar;